import { render, staticRenderFns } from "./informationAE.vue?vue&type=template&id=ad484f52&scoped=true"
import script from "./informationAE.vue?vue&type=script&lang=js"
export * from "./informationAE.vue?vue&type=script&lang=js"
import style0 from "./informationAE.vue?vue&type=style&index=0&id=ad484f52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad484f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad484f52')) {
      api.createRecord('ad484f52', component.options)
    } else {
      api.reload('ad484f52', component.options)
    }
    module.hot.accept("./informationAE.vue?vue&type=template&id=ad484f52&scoped=true", function () {
      api.rerender('ad484f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/information/informationAE.vue"
export default component.exports